import { Component, OnInit } from '@angular/core';
import { Gb } from 'src/app/core/services/growthbook.service';

@Component({
  selector: 'app-reason-list-container',
  templateUrl: './reason-list-container.component.html'
})
export class ReasonListContainerComponent implements OnInit {
  public gb: Gb;
  public featureReady = false;
  public useV2 = false;

  async ngOnInit() {
    this.gb = new Gb();
    await this.gb.init();
    this.useV2 = this.gb.isOn('EM-754');
    this.featureReady = true;
  }
}
